import { getLanguageStore } from './tntd-layout/storage';

export const zh_CN = {
  globalNavigation: '全局导航',
  menuSearch: '菜单搜索',

  // QueryForm
  search: '搜索',
  reset: '重置',
  moreFiltering: '更多过滤',
  expand: '展开',
  collapse: '收起',

  // QueryListScene
  totalRecords: '共%s条记录',

  // user popover
  nameNull: '暂无昵称',
  personalSettings: '个人设置',
  changePwd: '修改密码',
  signOut: '退出',

  // Handle
  handleMore:'更多'
}

export const en_US = {
  globalNavigation: 'Global Navigation',
  menuSearch: 'Menu Search',


  // QueryForm
  search: 'Search',
  reset: 'Reset',
  moreFiltering: 'More filtering',
  expand: 'Expand',
  collapse: 'Collapse',

  // QueryListScene
  totalRecords: 'Total of %s records',

  // user popover
  nameNull: 'No nickname yet',
  personalSettings: 'Setting',
  changePwd: 'Change password',
  signOut: 'Sign out',

  // Handle
  handleMore:'More'
}

export const getText = (key, language = 'cn', ...params) => {
  const text = ({
    cn: zh_CN,
    en: en_US,
  }[language] || zh_CN)?.[key]

  if (params?.length) {
    return params.reduce((acc, cur) => {
      return acc.replace(/%s/, cur)
    }, text)
  }

  return text
}

export const getLanguage = () => getLanguageStore()|| 'cn'

export default { en_US, zh_CN }
